module.exports = __webpack_public_path__ + "img/1440.0bf3e992.jpg";